<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ menuTitle }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { canViewVerticalNavMenuLink } from '@/services/menu/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import useVerticalNavMenuLink from '@/components/menu/vertical-nav-menu-link/useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from '@/components/menu/vertical-nav-menu-link/mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge
  },

  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup ({ item }) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(item)

    const { meta, title } = item
    const menuTitle = title || meta.title

    return {
      isActive,
      linkProps,
      menuTitle,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink
    }
  }

}
</script>
